var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card card-outline card-info"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('ListEvaluations',{attrs:{"groupedEvaluations":_vm.evaluations.data || []}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Lista de Evaluaciones")])])
}]

export { render, staticRenderFns }